import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import Modal from "react-bootstrap/lib/Modal";
import Checkbox from "material-ui/Checkbox";
import {Label,Glyphicon} from "react-bootstrap/lib/utils";
import axios from "axios";
import toastr from "toastr";
import Dialog from "material-ui/Dialog";
import RaisedButton from "material-ui/RaisedButton";
import Button from "react-bootstrap/lib/Button";
import moment from "moment";
import EmployeeSS from "../../../../components/joiningForm/EmployeeSS";
import csvConvert from "../../../../classes/csvConvert";

const offerType = {"Offer Made": "Offer Made", "Offer Rejected": "Offer Rejected", "Joined": "Joined"}


function dateFormat(cell) {
  if (cell != null && cell != 'NA' && cell != 0)
    return <font>{new Date(cell).toDateString()}</font>
  else
    return 'NA';
}
function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  switch (row.offerStatus) {
    case "Offer Made":
      return 'color5';
    case 'Offer Rejected':
      return 'color3';
    case  'Joined':
      return 'blue';
    default:
      return '';
  }
}
function columnClassNameJFormat(fieldValue, row, rowIdx, colIdx) {
  switch (row.joiningFormStatus) {
    case "pending":
      return 'color5';
    case 'completed':
      return 'color4';

    default:
      return '';
  }
}
class NewJoinerTable extends React.Component {

  constructor() {
    super();
    this.state = {
      flag: {}, emailDialog: false, requestObjects: [],
      joiningDialog: false, teamLease: null,
      openId: false, empId: null, selected: null, confirm: false, errorDialog: false,result: []
    };
    this.closeEmailDialog = this.closeEmailDialog.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
    this.downloadCsvPersonal = this.downloadCsvPersonal.bind(this);
    this.openId = this.openId.bind(this);
    this.closeId = this.closeId.bind(this);
    this.showJoiners = this.showJoiners.bind(this);

  }

  closeId() {
    this.setState({openId: false})
  }

  openId(row) {
    this.setState({teamLease: row, openId: true})

  }

  closeEmailDialog() {
    this.setState({emailDialog: false})
  }

  downloadCsv() {
    let csvContent = new csvConvert();
    let dump = this.props.data;

    let tableData = csvContent.convertArrayOfJoinerObjectsToCSV({data: dump});
    console.log(tableData);
    let filename = moment(new Date()).format('YYYY-MM-DD');
    let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
    blob = window.URL.createObjectURL(blob);

    if (!tableData.match(/^data:text\/csv/i)) {
      tableData = 'data:text/csv;charset=utf-8,' + tableData;
    }

    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: blob});
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }



  downloadCsvPersonal(dump) {
    let csvContent = new csvConvert();


    let tableData = csvContent.convertArrayOfAnyObjectsToCSV({data: dump});
    console.log(tableData);
    let blob = new Blob([tableData], {type: "text/csv;charset=utf-8;"});
    blob = window.webkitURL.createObjectURL(blob);


    if (!tableData.match(/^data:text\/csv/i)) {
      tableData = 'data:text/csv;charset=utf-8,' + tableData;
    }
    tableData = encodeURI(tableData);
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: blob});
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }

  componentDidMount() {
    let flag = new Object();
    console.log(this.props.data);
    this.props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  componentWillReceiveProps(props) {
    let flag = new Object();
    console.log(props.data);
    props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }


  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  showJoiners() {
    return (
        this.state.result.map((node)=> {
                  return <li>Temporary Id- {node.id} , Name- {node.name}</li>
                })
      );
  }

  displayLinks(cell,row)
  {
    var hrefLink = "";
    process.env.NODE_ENV
    if(process.env.NODE_ENV === 'production')
    {
        hrefLink = "https://onboarding.quikrcorp.com";
    }
    else
    {
        hrefLink = "https://onboarding.quikrcorp.com";
    }
    return `<div>
          <a target='_blank' href="` + hrefLink +`/getForm11Data?hrmsTempId=` +row.id + `">
            <span>Form 11 </span>
            <i class='glyphicon glyphicon-file'></i>
          </a><br>
          <a target='_blank' href="` + hrefLink +`/getEPFNominationData?hrmsTempId=` +row.id + `">
            <span>EPF Nomination</span>
            <i class='glyphicon glyphicon-file'></i>
          </a><br>
          <a target='_blank' href="` + hrefLink +`/getEmployeeJoiningFormData?hrmsTempId=` +row.id + `">
            <span>Employee Joining Form</span>
            <i class='glyphicon glyphicon-file'></i>
          </a><br>
          <a target='_blank' href="` + hrefLink +`/getGratuityNominationFormFData?hrmsTempId=` +row.id + `">
            <span>Gratuity Nomination Form F</span>
            <i class='glyphicon glyphicon-file'></i>
          </a>      
        </div>`;
  }
  render() {
    const locationType = this.props.constants.locationFilter;
    const verticalType = this.props.constants.verticalFilter;
    const options = {
      clearSearch: true,
      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };
    console.log(this.state.flag);
    const closeErrorDialog = [
      <RaisedButton
        label = "Ok"
        secondary={true}
        onTouchTap={()=> {
          this.setState({errorDialog: false})
        }}
    />];
    const actionsDecline = [
      <RaisedButton
        label="Cancel"
        secondary={true}
        onTouchTap={()=> {
          this.setState({joiningDialog: false})
        }}
      />];

    const actionDecline = [
      <RaisedButton
        label="Cancel"
        secondary={true}
        onTouchTap={this.closeEmailDialog}
      />,
      <RaisedButton

        label="Confirm Joiners and Send Email"
        primary={true}
        disabled={false}
        onTouchTap={()=> {
          this.setState({emailDialog: false, confirm: true});
          axios.post(process.env.REQ_URL + "/onBoarding/saveJoinersList", {data: this.state.requestObjects}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
            this.props.refresh();
            this.setState({emailDialog: false, confirm: false});
            console.log(response.data.data);
            var result = new Array();
            for(var i =0;i<response.data.data.length;i++)
            {
              if(response.data.data[i].empId==null)
              {
                result.push(response.data.data[i]);
              }
            }
            if(result.length == 0)
            {
                toastr.success("Saved");
            }
            else
            {
                this.setState({result: result, errorDialog: true});
            }           
          }).catch((error)=> {
            toastr.error("Error Occurred");
            console.log(error);
          })
        }}
      />,];

    return (
      <div >
        <Button
          onClick={this.downloadCsv}
          style={{backgroundColor: 'rgb(92, 184, 92)'}}
        ><i className="glyphicon glyphicon-download-alt">&nbsp;</i>Download</Button>

        <button className="btn btn-default"
                disabled={this.state.confirm}
                style={{marginLeft: '10px',}}
                onClick={()=> {
                  let requestObjects = new Array();
                  this.props.data.map((node)=> {

                    if (this.state.flag[node.id] == true) {
                      let requestObject = new Object();
                      Object.assign(requestObject, node);
                      requestObject.offerStatus = 'Joined';
                      requestObject.joiningFormStatus = 'pending'
                      requestObjects.push(requestObject);
                    }
                  })
                  if (requestObjects.length == 0)
                    toastr.error("Select Employees");
                  else
                    this.setState({requestObjects: requestObjects, emailDialog: true});
                }}
        >Confirm Joiners
        </button>
        <a href={this.state.csv} download={"Employee_Personal_Details.csv"} ref={(input) => {
          this.download = input;
        }}/>
        <button
          style={{marginLeft: '10px'}}
          className="btn btn-default"
          onClick={()=> {
            axios.get(process.env.REQ_URL + "/aboutEmpPersonalDetails?q=joiner", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
              this.downloadCsvPersonal(response.data.data);
            }).catch((error)=> {
            });
          }}
        >Download Personal Details
        </button>


        <a href={this.state.csv} download={"OnBoarding" + moment(new Date()).format('YYYY-MM-DD') + ".csv"}
           ref={(input) => {
             this.download = input;
           }}/>
        <BootstrapTable
          exportCSV={true}
          containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
          headerStyle={{
            borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
            , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
          }}
          search={true}
          striped
          options={options}
          pagination
          data={this.props.data}>
          <TableHeaderColumn hidden={true} isKey={true} dataField="id">Id</TableHeaderColumn>
          <TableHeaderColumn hidden={false} width={50} dataFormat={(cell, row)=> {
            return <Checkbox
              disabled={row.offerStatus == 'Joined' || (row.payroll == 'Team Lease' || row.payroll==' NEEM' || row.payroll =='Contract'  || row.payroll =='Intern') ? true : false}
              checked={this.state.flag[row.id]}
              onCheck={(event, isInputChecked)=> {
                let flag = this.state.flag;
                flag[row.id] = isInputChecked;
                this.setState({flag: flag});

              }}/>
          }} dataField="id">Id</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'TextFilter', delay: 0, placeholder: 'Empid'} }
            dataFormat={(cell, row)=> {
              if (row.empId != null)
                return row.empId;
              else if (row.payroll == 'Team Lease' || row.payroll =='NEEM' || row.payroll =='Contract'  || row.payroll =='Intern')
                return <a onClick={()=> {
                  this.openId(row);
                }}>Create EmpID</a>
              else return null;
            }}

            dataSort={true} width={120} dataField="empId">EmpId</TableHeaderColumn>
          <TableHeaderColumn dataSort={true}
                             filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }
                             dataFormat={(cell, row)=> {
                               return <a onClick={()=> {
                                 this.props.viewDetails(row.id)
                               }}>{cell}</a>
                             }}
                             dataField="name">Name</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'SelectFilter', options: locationType, placeholder: 'Location'} }
            dataField="location">Location</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'SelectFilter', options: verticalType, placeholder: 'Vertical'} }

            dataField="vertical">Vertical</TableHeaderColumn>
          <TableHeaderColumn
            filter={ {type: 'TextFilter', delay: 0, placeholder: 'yyyy-mm-dd'} }
            dataFormat={dateFormat} dataField="oD">Offer Date</TableHeaderColumn>
          <TableHeaderColumn dataFormat={dateFormat}
                             filter={ {type: 'TextFilter', delay: 0, placeholder: 'yyyy-mm-dd'} }
                             dataField="jD">Date Of Joining</TableHeaderColumn>

          <TableHeaderColumn
            columnClassName={ columnClassNameFormat }
            filter={ {type: 'SelectFilter', options: offerType, placeholder: 'Offer Status'} }
            dataField="offerStatus">Offer Status</TableHeaderColumn>
          <TableHeaderColumn
            columnClassName={ columnClassNameJFormat }
            filter={ {
              type: 'SelectFilter',
              options: {"completed": "completed", "pending": "pending"},
              placeholder: 'Joining Form'
            } }
            dataFormat={(cell, row)=> {
              return <a onClick={()=> {
                this.setState({joiningDialog: true, selected: {empno: row.empId}})
              }}>{cell}</a>
            }}
            dataField="joiningFormStatus">Joining Form</TableHeaderColumn>
            <TableHeaderColumn width={250} dataFormat = {this.displayLinks} dataField="formLinks">
                Links     
            </TableHeaderColumn>
        </BootstrapTable>

        <Dialog
          title="Joiner Details"
          actions={actionsDecline}
          contentStyle={{height: "60%", maxWidth: 'none', width: '80%'}}
          autoScrollBodyContent={true}
          autoDetectWindowHeight={true}
          width="80%"
          modal={false}
          onRequestClose={()=> {
            this.setState({joiningDialog: false})
          }}
          open={this.state.joiningDialog}
        >
          <div style={{"font-family": '"Roboto", "sans-serif"'}}>
            <EmployeeSS changeBanner={(name)=> {
              return null;
            }} showAll={false} employee={this.state.selected}/>
          </div>
        </Dialog>


        <Dialog
          title="Send Confirmed Joiners Email"
          actions={actionDecline}
          contentStyle={{height: "60%"}}
          autoScrollBodyContent={true}
          autoDetectWindowHeight={true}
          modal={false}
          open={this.state.emailDialog}
        >
          <div style={{"font-family": '"Roboto", "sans-serif"'}}>
            Send email to IT, Finance, Facilities, Vertical Head and the Manager.
            <br/><br/>
            Confirm Candidates and create Employee Id's
            <ul>
              {this.state.requestObjects.map((node)=> {
                return <li>{node.name}</li>
              })}
            </ul>
          </div>
        </Dialog>


        <Dialog
          title = "Error in confirming the joinees"
          actions={closeErrorDialog}
          contentStyle={{height: "60%", maxWidth: 'none', width: '50%'}}
          autoScrollBodyContent={true}
          autoDetectWindowHeight={true}
          width="50%"
          modal={false}
          onRequestClose={()=> {
            this.setState({errorDialog: false})
          }}
          open={this.state.errorDialog}>
          <div>
            Some joiners are not Verified
            <br></br>
              <ul>
                {this.showJoiners()}
              </ul>
          </div>

        </Dialog>

        {this.state.teamLease != null ?
          <Modal
            bsSize="small"
            show={this.state.openId} onHide={this.closeId}>
            <Modal.Header closeButton>
              <Modal.Title>Create Employee Id</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{fontSize: '20px'}}>
                Name: {this.state.teamLease.name}
                <br/>
                Employee Id: <br/>
                <input
                  onChange={(event)=> {
                    this.setState({empId: event.target.value})

                  }}
                  type="text"/>
                <br/><br/>
                <button
                  onClick={()=> {

                    let requestObject = this.state.teamLease;
                    requestObject.empId = this.state.empId;
                    axios.post(process.env.REQ_URL + "/onBoarding/saveTeamLeaseJoiner", {data: [requestObject]}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                      this.setState({openId: false, empId: null});
                      this.props.refresh();
                      toastr.success("Saved");
                    }).catch((error)=> {
                      console.log(error);
                    })
                  }}
                  className="btn btn-default">Save & Confirm Joiner
                </button>
              </div>

            </Modal.Body>
          </Modal> : null}


      </div>
    );
  }
}

NewJoinerTable.propTypes = {};

export default NewJoinerTable;





/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/onboarding/components/NewJoinerTable.js
 **/